import Home from "@/pages/Home";
import Mine from "@/pages/Mine";
import Init from "@/pages/Init";
import Members from "@/pages/Members";
import Finance from "@/pages/Finance";
import RecentlyRecharge from "@/pages/RecentlyRecharge";
import GameRecords from "@/pages/GameRecords";
import PersonnalRecords from "@/pages/PersonnalRecords";
import SearchResult from "@/pages/SearchResult";
import DaicunRecord from "@/pages/DaicunRecord";
import ManageMembers from "@/pages/ManageMembers";
import AddMembers from "@/pages/AddMembers";
import Login from "@/pages/Login";
import Game from "@/pages/Game";
import PartnerGame from "@/pages/PartnerGame";
import RecordsGift from "@/pages/RecordsGift";
import ManagePlan from "@/pages/ManagePlan";
import PersonnalGameRecords from "@/pages/PersonnalGameRecords";
import PersonnalUserRecords from "@/pages/PersonnalUserRecords";
import PersonnalCoinRecords from "@/pages/PersonnalCoinRecords";
import PersonnalReceiveRecords from "@/pages/PersonnalReceiveRecords";
import OtherMember from "@/pages/OtherMember";
import SearchGame from "@/pages/SearchGame";
import Wallet from "@/pages/Wallet";
import PersonalData from "@/pages/PersonalData";
import GameRecordsNow from "@/pages/GameRecordsNow";
import CashbackRecord from "@/pages/CashbackRecord";
import VaultManage from "@/pages/VaultManage";
import CashbackManage from "@/pages/CashbackManage";
import LowerMembers from "@/pages/LowerMembers";
import AgentManag from "@/pages/AgentManag";
import RecommendRecords from "@/pages/Recommend";

export const basePath = "/";

export interface RouteConfig {
	path: string;
	element: JSX.Element;
	auth: boolean;
	keepAlive: boolean;
	children?: RouteConfig[];
}

const routes: RouteConfig[] = [
	// {
	// 	path: basePath,
	// 	element: <Navigate replace to="/game" />,
	// 	auth: true,
	// 	keepAlive: true,
	// },
	{
		path: basePath,
		element: <Init />,
		auth: true,
		keepAlive: false,
		children: [
			{
				path: "home",
				element: <Home />,
				auth: true,
				keepAlive: false,
			},
			{
				path: "members",
				element: <Members />,
				auth: true,
				keepAlive: false,
			},
			{
				path: "finance",
				element: <Finance />,
				auth: true,
				keepAlive: false,
			},
			{
				path: "mine",
				element: <Mine />,
				auth: true,
				keepAlive: false,
			},
		],
	},
	{
		path: basePath + "/other-member",
		element: <OtherMember />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/recently-recharge",
		element: <RecentlyRecharge />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/game-records",
		element: <GameRecords />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/personnal-records/:uid/:outerParams",
		element: <PersonnalRecords />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/personnal-game-records/:uid/:outerParams",
		element: <PersonnalGameRecords />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/personnal-user-records/:uid/:outerParams",
		element: <PersonnalUserRecords />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/personnal-coin-records/:uid/:outerParams",
		element: <PersonnalCoinRecords />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/personnal-receive-records/:uid/:outerParams",
		element: <PersonnalReceiveRecords />,
		auth: true,
		keepAlive: false,
	},

	{
		path: basePath + "/search-result",
		element: <SearchResult />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/daicun-record/:type",
		element: <DaicunRecord />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/records-gift",
		element: <RecordsGift />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/manage-members",
		element: <ManageMembers />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/add-members",
		element: <AddMembers />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/login",
		element: <Login />,
		auth: false,
		keepAlive: false,
	},
	{
		path: basePath + "/game",
		element: <Game />,
		auth: true,
		keepAlive: true,
	},
	{
		path: basePath + "/partnergame/:type?",
		element: <PartnerGame />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/manage-plan",
		element: <ManagePlan />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/searchGame",
		element: <SearchGame />,
		auth: true,
		keepAlive: false,
	},

	{
		path: basePath + "/wallet/:type/:state?",
		element: <Wallet />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/personalData",
		element: <PersonalData />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/gameRecordsNow",
		element: <GameRecordsNow />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/cashbackRecord",
		element: <CashbackRecord />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/vaultManage",
		element: <VaultManage />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/cashbackManage",
		element: <CashbackManage />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/lowerMembers",
		element: <LowerMembers />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/agentManag",
		element: <AgentManag />,
		auth: true,
		keepAlive: false,
	},
	{
		path: basePath + "/recommend",
		element: <RecommendRecords />,
		auth: true,
		keepAlive: false,
	},
];

export default routes;
